import { render, staticRenderFns } from "./LegendList.vue?vue&type=template&id=1e6fff16&scoped=true"
import script from "./LegendList.vue?vue&type=script&lang=js"
export * from "./LegendList.vue?vue&type=script&lang=js"
import style0 from "./LegendList.vue?vue&type=style&index=0&id=1e6fff16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fff16",
  null
  
)

export default component.exports